import { Eye } from "lucide-react";
import { previewCode } from "@/context/SiteContent";

export const PreviewBadge = () => (
  <div className="preview-badge" data-testid="preview-badge">
    <Eye size={14} /> Preview mode. The public sees the Coming Soon page.
    <button type="button" onClick={() => { previewCode.clear(); window.location.href = "/"; }} data-testid="preview-badge-exit">Exit</button>
  </div>
);
